import { Download, X } from 'lucide-react'
import { useState } from 'react'
import { useInstallPrompt } from '@symphenia/ui-components'
import { cn } from '@/lib/utils'

/**
 * Dezenter Banner, der erscheint, wenn der Browser die Installation des
 * ERP als App anbietet (Add-to-Home-Screen / Desktop-Installation).
 * Wird nach dem Ablehnen für diese Session ausgeblendet (kein localStorage –
 * erscheint nach Neustart erneut, solange der User sich nicht entschieden hat).
 */
export function InstallBanner({ className }: { className?: string }) {
  const { canInstall, install, isInstalled } = useInstallPrompt()
  const [dismissed, setDismissed] = useState(false)

  // Nicht anzeigen wenn: bereits installiert, kein Prompt verfügbar, oder dismissed
  if (isInstalled || !canInstall || dismissed) return null

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 shadow-sm',
        className,
      )}
    >
      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <Download size={20} className="text-primary" />
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium leading-snug text-foreground">App installieren</p>
        <p className="mt-0.5 text-xs leading-snug text-muted-foreground">
          Symphenia als Anwendung speichern – schneller Zugriff direkt vom Desktop
        </p>
      </div>

      <button
        onClick={install}
        className="shrink-0 rounded-lg bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground transition-all hover:bg-primary/90 active:scale-95"
      >
        Installieren
      </button>

      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 rounded-md p-1 text-muted-foreground transition-colors hover:bg-muted"
        aria-label="Schließen"
      >
        <X size={16} />
      </button>
    </div>
  )
}
